export const isAndroid = (): boolean =>
  /Android/i.test(global.navigator.userAgent)

export const isIOS = (): boolean =>
  /iPhone|iPad|iPod/i.test(global.navigator.userAgent)

export const isAppAndroid = (): boolean =>
  global.navigator.userAgent.indexOf('GoNativeAndroid') !== -1 ||
  (isAndroid() && isReactNative())

export const isAppIOS = (): boolean =>
  global.navigator.userAgent.indexOf('GoNativeIOS') !== -1 ||
  (isIOS() && isReactNative())

export const isWebIOS = (): boolean =>
  !isAppIOS() && /iPhone|iPad|iPod/i.test(global.navigator.userAgent)

export const isApp = (): boolean => isAppAndroid() || isAppIOS()

export const isBrowser = (): boolean => !isAppAndroid() && !isAppIOS()

export const isDesktop = (): boolean => !isApp() && !isWebIOS()

export const isReactNative = (): boolean =>
  global.navigator.userAgent.indexOf('Hublo/2+') !== -1
